/**
 * @description Simple hook that retrieves the list of available SECCON fields from the backend
 */

import React from 'react';

import { ToastContext } from '@seccon/core/contexts/toast';
import decodeJson from '@seccon/shared/utils/decodeJson';

const CATEGORIES = {
  clearanceFields: { label: 'Clearance Fields' },
  polygraphInformationFields: { label: 'Polygraph Information Fields' },
  customFieldTypes: { label: 'Personnel Fields' },
  investigationFields: { label: 'Investigation Fields' },
  personnelFields: { label: 'Personnel Fields' },
  personnelSpecialAccessFields: { label: 'Special Access Fields' }
};

const useAvailableFields = () => {
  const [availableFields, setAvailableFields] = React.useState(null);
  const toastApi = React.useContext(ToastContext);

  /**
   * Handles successful retrieval of available fields
   * @param response {object} - API response
   */
  function handleSuccess (response) {
    const results = [];

    try {
      for (const key in response) {
        if (key in CATEGORIES) {
          const fieldList = response[key].sort((fieldA, fieldB) => fieldA.localeCompare(fieldB, 'en', { sensitivity: 'base' }));

          for (const field of fieldList) {
            results.push({
              label: field.split('.')[1] ?? field,
              value: field,
              category: CATEGORIES[key].label
            });
          }
        }
      }
    } catch (err) {
      console.error(err);
    }

    setAvailableFields(results);
  }

  /**
   * Handles failed retrieval of the mapping names
   */
  function handleFailure () {
    toastApi.error('Security Control field list could not be retrieved. Reload the page and try again.');
  }

  React.useEffect(() => {
    // If the available fields are already defined, do nothing
    if (availableFields !== null) {
      return;
    }

    fetch('/mappings/fields')
      .then(decodeJson)
      .then(handleSuccess)
      .catch(handleFailure)
  }, []);

  return availableFields;
};

export default useAvailableFields;
